import CoreuiController from "../lib/coreui-controller"
import Modal from "../coreui/modal"

// AJAX responses set openValue, which also works before Stimulus connects.
export default class CoreuiModalController extends CoreuiController {
  static Component = Modal
  static values = { open: Boolean }

  instanceMounted() {
    this.instance.listen(this.element, "hidden.coreui.modal", () => { this.openValue = false })
    if (this.openValue) this.openValueChanged(true)
  }

  openValueChanged(open) {
    if (!this.instance) return
    open ? this.instance.show() : this.instance.hide()
    if (open && !this.instance.shown) this.openValue = false
  }

  show(event) {
    super.show(event)
    this.openValue = Boolean(this.instance?.shown)
  }

  toggle(event) {
    this.instance?.shown ? this.hide() : this.show(event)
  }

  hide() {
    this.openValue = false
    super.hide()
  }

  prepareForCache() {
    this.openValue = false
    super.prepareForCache()
  }
}
